import { Outlet } from 'react-router'

import { Container } from '../../components/Container'
import { PrivateNavigation } from './PrivateNavigation'

export function NavigationLayout() {
  return (
    <>
      <PrivateNavigation />
      <Container className="mt-10 flex flex-1 flex-col">
        <Outlet />
      </Container>
    </>
  )
}
